export default __webpack_public_path__ + "static/media/court.1ec3c071.png";